import { FareSaleOriginSelection } from '@store/fare-sale/types';

interface Anywhere {
  kind: 'Anywhere';
}

interface ConcreteSelection extends FareSaleOriginSelection {
  kind: 'Concrete';
}

export type FareSaleAirportSelection = Anywhere | ConcreteSelection;

export const anywhere: Anywhere = { kind: 'Anywhere' };

export const concreteSelection = (
  fareSale: FareSaleOriginSelection,
): ConcreteSelection => ({
  ...fareSale,
  kind: 'Concrete',
});
